import Dropdown from 'bootstrap/js/dist/dropdown'
import Collapse from 'bootstrap/js/dist/collapse'

import { initSearchControl } from './search'
import { initMenuSticky } from './sticky-menu.js'
import { initMenuControl } from './menu-control.js'
import { initCommentModerationNotice, initCommentValidation ,initNiaApprovedComment } from './nia-approved-comment.js'

import './filter.js'
import './tom-select.js'
document.addEventListener('DOMContentLoaded', () => {
    initNiaApprovedComment()
    initCommentModerationNotice()
    initCommentValidation()
    initMenuSticky()
    initMenuControl()
    initSearchControl()
})
